const formatDistanceShort = {
  lessThanXSeconds: 'Сейчас',
  xSeconds: 'Сейчас',
  halfAMinute: 'Сейчас',
  lessThanXMinutes: '{{count}} м',
  xMinutes: '{{count}} м',
  aboutXHours: '{{count}} ч',
  xHours: '{{count}} ч',
  xDays: '{{count}} д',
};

const formatDistanceFull = {
  lessThanXSeconds: 'Сейчас',
  xSeconds: 'Сейчас',
  halfAMinute: 'Сейчас',
  lessThanXMinutes: '{{count}} мин. назад',
  xMinutes: '{{count}} мин. назад',
  aboutXHours: '{{count}} ч. назад',
  xHours: '{{count}} ч. назад',
  xDays: '{{count}} д. назад',
};

export default function formatDistance(token, count, options) {
  const locale = options?.addSuffix ? formatDistanceFull : formatDistanceShort;
  const result = locale[token]?.replace('{{count}}', count);
  return result;
}
